import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { AddressClientCreateComponent } from '../../../address/address-client-create/address-client-create.component'
import { ContactClientCreateComponent } from '../../../contact/contact-client-create/contact-client-create.component'
import { TaxDocumentClientCreateComponent } from '../../../tax-document/tax-document-client-create/tax-document-client-create.component'
import { PaymentMethodsClientCreateComponent } from '../../../payment/payment-client-create/payment-methods-client-create.component'
import { BankDetailsClientCreateComponent } from '../../../bank/bank-details-client-create/bank-details-client-create.component'
import { ConsultantClientCreateComponent } from '../../../person/consultant-client-create/consultant-client-create.component'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { JsonPipe, NgClass } from '@angular/common'
import { AssociateClientCreateComponent } from '../associate-client/associate-client-create/associate-client-create.component'
import { SubClientService } from '../../../../core/services/customer/sub-client/sub-client.service'
import { TariffClientCreateComponent } from '../../../tariff/tariff-client-create/tariff-client-create.component'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { DecimalInputDirective } from '../../../../shared/directives/decimalInput'
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle'
import { convertCurrency } from '../../../../shared/utils/utils'
import { CommissionDividerService } from '../../../../core/services/price-quote/commission-divider/commission-divider.service'
import { ResponsibleClientCreateComponent } from '../../../person/responsible-client-create/responsible-client-create.component'
import { AssociateSubClientCreateComponent } from '../../client-create/associate-sub-client-create/associate-sub-client-create.component'
import { AssociateConsultantOperateCreateComponent } from '../../../employee/associate-consultant-operate-create/associate-sub-client-create.component'
import { cnpjValidator } from '../../../../shared/utils/cnpj_validator'
import { cpfValidator } from '../../../../shared/utils/cpf_validator'

@Component({
  selector: 'sub-client-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatDividerModule,
    AddressClientCreateComponent,
    ContactClientCreateComponent,
    TaxDocumentClientCreateComponent,
    PaymentMethodsClientCreateComponent,
    BankDetailsClientCreateComponent,
    ConsultantClientCreateComponent,
    NgxMaskDirective,
    AssociateClientCreateComponent,
    TariffClientCreateComponent,
    CurrencyInputDirective,
    DecimalInputDirective,
    MatSlideToggle,
    ResponsibleClientCreateComponent,
    AssociateSubClientCreateComponent,
    JsonPipe,
    AssociateConsultantOperateCreateComponent,
    MatOption,
    MatSelect,
    NgClass,
  ],
  templateUrl: './sub-client-create.component.html',
  styleUrl: './sub-client-create.component.scss',
  providers: [SubClientService, CommissionDividerService],
  standalone: true,
})
export class SubClientCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    // private legalEntityClientService: LegalEntityClientService,
    private commissionDividerService: CommissionDividerService,
    private subClientService: SubClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<SubClientCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data.modal) {
      this.modal = this.data.modal
    }
    if (this.data.item) {
      this.item = { client: true, clientData: this.data.item }
    }
  }

  @Output() responseCreate = new EventEmitter()
  @Output() responseModal = new EventEmitter()

  item: any = { client: false, clientData: null }

  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})
  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]

  typeClient: 'legal' | 'individual' = 'legal'

  ListPersonType: any[] = [
    { value: 'PF', description: 'Pessoa Fisica' },
    { value: 'PJ', description: 'Pessoa Jurídica' },
  ]

  individualPerson = false

  modal = false
  loading = false

  addressList: any[] = []
  contactList: any[] = []
  taxDocumentList: any[] = []
  paymentMethodsList: any[] = []
  bankDetailsList: any[] = []
  consultantList: any[] = []
  consultantOpList: any[] = []
  tariffList: any[] = []
  clientList: any[] = []
  responsibleList: any[] = []

  commissionDivider: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  panelAdress = false
  panelContact = false
  panelResponsable = false
  panelFinancial = false
  panelBankDetails = false
  panelConsultant = false
  panelConsultantOp = false
  panelTariff = false
  panelSubClient = false

  ngOnInit(): void {
    this.createForm()
    this.getCommissionDivider()
  }

  close() {
    this.responseCreate.emit()
    this.dialogRef.close()
  }

  private getDocumentValidator(): ValidatorFn {
    return this.individualPerson ? cpfValidator() : cnpjValidator()
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      personType: ['PJ', [Validators.required]],
      name: ['', [Validators.required]],
      cnpj: ['', [Validators.required, this.getDocumentValidator()]],
      corporate_name: ['', [Validators.required]],
      reg_state: [''],
      reg_municipal: [''],
      isClient: ['N'],
    })
    this.formIndividual = this.formBuilder.group({
      name: ['', [Validators.required]],
      // cpf: [
      //   '',
      //   [Validators.required, Validators.pattern(/\d{3}\.\d{3}\.\d{3}-\d{2}/)],
      // ],
      cpf: ['', [Validators.required]],
    })
    this.formFinancial = this.formBuilder.group({
      // commission: ['', [Validators.required]],
      // divider: ['', [Validators.required]],
      tgmob: [true],
      tax: [convertCurrency(0)],
      commission: [convertCurrency(0)],
      divider: [convertCurrency(0)],
    })
  }

  getList(
    list: any[],
    typeList:
      | 'address'
      | 'contact'
      | 'tax_document'
      | 'paymentMethod'
      | 'bankDetails'
      | 'consultant'
      | 'taxDocument'
      | 'tariff'
      | 'responsible'
      | 'associateClients'
      | 'associateConsultantOp',
  ): void {
    switch (typeList) {
      case 'address':
        this.addressList = list
        break
      case 'contact':
        this.contactList = list
        break
      case 'bankDetails':
        this.bankDetailsList = list
        break
      case 'consultant':
        this.consultantList = list
        break
      case 'associateConsultantOp':
        this.consultantOpList = list
        break
      case 'taxDocument':
        this.taxDocumentList = list
        break
      case 'paymentMethod':
        this.paymentMethodsList = list
        break
      case 'tariff':
        this.tariffList = list
        break
      case 'associateClients':
        this.clientList = list
        break
      case 'responsible':
        this.responsibleList = list
        break
    }
  }

  checkInvalidForm() {
    if (
      (this.typeClient == 'legal' && this.formLegalEntity.invalid) ||
      (this.typeClient == 'individual' && this.formIndividual.invalid) ||
      // this.formFinancial.invalid ||
      // this.addressList.length == 0 ||
      // this.contactList.length == 0 ||
      // this.taxDocumentList.length == 0 ||
      // this.paymentMethodsList.length == 0 ||
      // this.bankDetailsList.length == 0 ||
      // this.consultantList.length == 0 ||
      // this.consultantOpList.length == 0 ||
      // this.responsibleList.length == 0 ||
      // this.tariffList.length == 0 ||
      this.clientList.length == 0 ||
      this.loading
    ) {
      return true
    } else {
      return false
    }
  }

  createLegalModel() {
    return {
      subcliente: {
        nome: this.formLegalEntity.get('name')?.value ?? '',
        razaoSocial: this.individualPerson
          ? 'PF'
          : (this.formLegalEntity.get('corporate_name')?.value ?? ''),
        inscMunicipal: this.individualPerson
          ? ''
          : (this.formLegalEntity.get('reg_municipal')?.value ?? ''),
        inscEstadual: this.individualPerson
          ? ''
          : (this.formLegalEntity.get('reg_state')?.value ?? ''),
        cnpj: this.formLegalEntity.get('cnpj')?.value ?? '',

        // nome: this.formLegalEntity.get('name')?.value ?? '',
        // razaoSocial: this.formLegalEntity.get('corporate_name')?.value ?? '',
        // inscMunicipal: this.formLegalEntity.get('reg_municipal')?.value ?? '',
        // inscEstadual: this.formLegalEntity.get('reg_state')?.value ?? '',
        // cnpj: this.formLegalEntity.get('cnpj')?.value ?? '',

        clienteId: this.clientList,
        isCliente:
          this.formLegalEntity.get('isClient')?.value == 'S' ? 'S' : 'N',
      },
      divisorComissao: {
        isCliente: this.formFinancial.get('tgmob')?.value ? 'N' : 'S',
        taxa: convertCurrency(this.formFinancial.get('tax')!.value),
        comissao: convertCurrency(this.formFinancial.get('commission')!.value),
        divisor: convertCurrency(this.formFinancial.get('divider')!.value),
      },
      enderecos: this.addressList.map(
        (ele) => {
          return {
            tipoEnderecoId: ele.tipo_endereco_id,
            cep: ele.cep,
            logradouro: ele.logradouro,
            numero: ele.numero,
            complemento: ele.complemento,
            bairro: ele.bairro,
            estado: ele.estado,
            cidade: ele.cidade,
            pais: ele.pais,
            latitude: ele.latitude,
            longitude: ele.longitude,
          }
        },
        // ({ tipo_endereco, idCreate, ...remainder }) => remainder,
      ),
      contatos: this.contactList.map(
        ({ tipoContato, idCreate, ...remainder }) => remainder,
      ),
      documentoFiscal: this.taxDocumentList.map(
        (ele: any) => ele.tipo_documento_id,
      ),
      consultoresOperacionais: this.consultantOpList.map((ele: any) => ele),
      formaPagamento: this.paymentMethodsList.map(
        (ele) => {
          return {
            tipoPagamentoId: ele.tipo_pagamento_id,
            prazo: ele.prazo,
          }
        },
        // ({ tipo_pagamento, idCreate, ...remainder }) => remainder,
      ),
      dadosBancarios: this.bankDetailsList.map(
        ({ bancoDesc, idCreate, ...remainder }) => remainder,
      ),
      consultores: this.consultantList.map(
        ({ idCreate, ...remainder }) => remainder,
      ),
      tarifarios: this.tariffList.map(
        (ele) => {
          return {
            origemId: ele.origemId,
            destinoId: ele.destinoId,
            tipoServicoId: ele.tipoServicoId,
            servicoId: ele.servicoId,
            tipoVeiculoId: ele.tipoVeiculoId,
            tipoMotoristaId: ele.tipoMotoristaId,
            fornecedorId: ele.fornecedorId,
            custo: ele.custo,
            custoHoraExtra: ele.custoHoraExtra,
            custoKmExtra: ele.custoKmExtra,
            ativo: ele.ativo,
            dataValidade: ele.dataValidade,
            perimetroUrbano: ele.perimetroUrbano,
            standard: 'N',
            // standard: ele.standard,
          }
        },
        // ({ idCreate, ...remainder }) => remainder,
      ),
      responsaveis: this.responsibleList.map(
        ({ idCreate, ...remainder }) => remainder,
      ),
    }
  }

  createIndividualModel() {
    return {
      nome: this.formLegalEntity.get('name')?.value ?? '',
      cpf: this.formLegalEntity.get('cpf')?.value ?? '',
      enderecos: this.addressList,
      contatos: this.contactList,
      documento_fiscal: this.taxDocumentList,
      forma_pagamento: this.paymentMethodsList,
      dados_bancarios: this.bankDetailsList,
      consultores: this.consultantList,
      // consultoresOp: this.consultantOpList,
      // comissao: this.formFinancial.get('commission')?.value ?? '',
      // divisao: this.formFinancial.get('divider')?.value ?? '',
      // tarifarios: this.tariffList,
      // sub_clientes: this.subClientList,
    }
  }

  createClient() {
    this.loading = true
    if (this.typeClient == 'legal') {
      this.createClientLegal()
    } else if (this.typeClient == 'individual') {
      this.createClientIndividual()
    } else {
      this.snackbar.error('Selecione um tipo de Cliente')
    }
  }

  onChangeSelect(event: MatSlideToggleChange) {
    if (event.checked) {
      this.fillFormFinancial()
    } else {
      this.fillFormFinancial(true)
    }
  }

  fillFormFinancial(clear = false) {
    if (!clear) {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDivider.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDivider.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDivider.comissao))
      this.formFinancial.get('divider')!.disable()
      this.formFinancial.get('tax')!.disable()
      this.formFinancial.get('commission')!.disable()
    } else {
      this.formFinancial.get('divider')!.setValue(convertCurrency(0))
      this.formFinancial.get('tax')!.setValue(convertCurrency(0))
      this.formFinancial.get('commission')!.setValue(convertCurrency(0))
      this.formFinancial.get('divider')!.enable()
      this.formFinancial.get('tax')!.enable()
      this.formFinancial.get('commission')!.enable()
    }
  }

  getCommissionDivider() {
    this.commissionDividerService.getCommissionDividerDefault().subscribe({
      next: (response: ResponseRequestModel) => {
        this.commissionDivider = {
          taxa:
            response && response.data && response.data.taxa
              ? response.data.taxa
              : 0,
          divisor:
            response && response.data && response.data.divisor
              ? response.data.divisor
              : 1,
          comissao:
            response && response.data && response.data.comissao
              ? response.data.comissao
              : 0,
        }
        // this.commissionDivider = {
        //   taxa: response.data.taxa,
        //   divisor: response.data.divisor,
        //   comissao: response.data.comissao,
        // }
        this.fillFormFinancial()
      },
      error: (err: ErrorRequestModel) => {
        console.error('err', err)
      },
      complete: () => {},
    })
  }

  createClientLegal() {
    this.subClientService.createSubClient(this.createLegalModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        if (this.modal) {
          this.responseModal.emit(response)
        } else {
          this.responseCreate.emit()
        }
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.formLegalEntity.reset()
        this.formFinancial.reset()
      },
    })
  }

  personTypeChange() {
    const value = this.formLegalEntity.get('personType')?.value
    if (value == 'PF') {
      this.individualPerson = true
      this.formLegalEntity.get('cnpj')?.setValue('')
      this.formLegalEntity.get('corporate_name')?.setValue('PF')
      this.formLegalEntity.get('reg_state')?.setValue('')
      this.formLegalEntity.get('reg_municipal')?.setValue('')
    } else {
      this.individualPerson = false
      this.formLegalEntity.get('cnpj')?.setValue('')
      this.formLegalEntity.get('corporate_name')?.setValue('')
      this.formLegalEntity.get('reg_state')?.setValue('')
      this.formLegalEntity.get('reg_municipal')?.setValue('')
    }
    this.formLegalEntity
      .get('cnpj')
      ?.setValidators([Validators.required, this.getDocumentValidator()])
  }

  createClientIndividual() {
    // this.individualClientService
    //   .createIndividualClient(this.createIndividualModel())
    //   .subscribe({
    //     next: (response: ResponseRequestModel) => {
    //       this.snackbar.success(response.message)
    //       this.responseCreate.emit()
    //       this.close()
    //     },
    //     error: (err: ResponseRequestModel) => {
    //       this.loading = false
    //       this.snackbar.error(err.error)
    //     },
    //     complete: () => {
    //       this.loading = false
    //       this.formIndividual.reset()
    //       this.formFinancial.reset()
    //     },
    //   })
  }
}
